import { render, staticRenderFns } from "./storage_add.vue?vue&type=template&id=9968bf84&scoped=true&"
import script from "./storage_add.vue?vue&type=script&lang=js&"
export * from "./storage_add.vue?vue&type=script&lang=js&"
import style0 from "./storage_add.vue?vue&type=style&index=0&id=9968bf84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9968bf84",
  null
  
)

export default component.exports